import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class FitIcon extends BaseIcon {
    getChildren = () => [
      <polygon fill={this.getColor()} points="0 0 0 2 0 6 2 6 2 2 6 2 6 0 2 0 0 0"/>,
      <polygon fill={this.getColor()} points="14 0 10 0 10 2 14 2 14 6 16 6 16 2 16 0 14 0"/>,
      <polygon fill={this.getColor()} points="2 10 0 10 0 14 0 16 2 16 6 16 6 14 2 14 2 10"/>,
      <polygon fill={this.getColor()} points="14 14 10 14 10 16 14 16 16 16 16 14 16 10 14 10 14 14"/>
    ]
    getViewBox = () => '0 0 16 16'
}
